const useRehashCard = () => {
    const rehash = (props) => {
        const { content_group, workspace, authorizations, assigned_users } = props;

        return {
            id: content_group.id,
            name: content_group.name,
            content_group,
            authorizations,
            assigned_users,
            workspace,
        }
    }

    return rehash
};

export {useRehashCard};